module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-news-oneImg-box"
  }, [_c('el-form', {
    ref: "oneImgNewsForm",
    attrs: {
      "rules": _vm.validateRules,
      "model": _vm.oneImgNewsForm,
      "label-width": "85px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "newsContentTitle"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.oneImgNewsForm.newsContentTitle),
      callback: function($$v) {
        _vm.oneImgNewsForm.newsContentTitle = $$v
      },
      expression: "oneImgNewsForm.newsContentTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.oneImgNewsForm.newsContentSource),
      callback: function($$v) {
        _vm.oneImgNewsForm.newsContentSource = $$v
      },
      expression: "oneImgNewsForm.newsContentSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片链接",
      "prop": "newsContentImage"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.oneImgNewsForm.newsContentImage),
      callback: function($$v) {
        _vm.oneImgNewsForm.newsContentImage = $$v
      },
      expression: "oneImgNewsForm.newsContentImage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新闻链接",
      "prop": "newsContentURL"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.oneImgNewsForm.newsContentURL),
      callback: function($$v) {
        _vm.oneImgNewsForm.newsContentURL = $$v
      },
      expression: "oneImgNewsForm.newsContentURL"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createOneImgNews('oneImgNewsForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clearOneImgNewsForm
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "preview-box"
  }, [_c('OneImgComponent', {
    attrs: {
      "newsData": {
        newsContentTitle: _vm.oneImgNewsForm.newsContentTitle,
        newsContentSource: _vm.oneImgNewsForm.newsContentSource,
        newsContentImage: _vm.oneImgNewsForm.newsContentImage,
        newsContentURL: _vm.oneImgNewsForm.newsContentURL,
        newsContentUpdateTime: ''
      },
      "isAd": false
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f9e6619c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/business/newsAddTemplate/OneImg.vue
// module id = 801
// module chunks = 1